import React, { useEffect, useState } from "react";
import slugify from "slugify";
import { Container } from "react-bootstrap";
import { RiMenu3Fill } from "react-icons/ri";
import { HiXMark } from "react-icons/hi2";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import "./NavBar.scss";
import logo from "../../assets/images/logo.png";

const NavBar = () => {
  const list = ["Lisbon map", "Areas", "Why recycle?", "About us", "Donate"];

  const [showMenu, setShowMenu] = useState(false);
  const [scrolledDown, setScrolledDown] = useState(false);
  const location = useLocation();
  
  const changeBg = () => {
    if (window.scrollY >= 72) setScrolledDown(true);
    else setScrolledDown(false);
  };

  window.addEventListener("scroll", changeBg);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location])

  return (
    <nav className={`app-navbar ${scrolledDown ? "scroll" : ""}`}>
      <Container>
        <Link to={"/"}>
          <img src={logo} alt="logo" className="logo" />
        </Link>
        <div className="content">
          <div
            className={`list ${showMenu ? "show" : ""}`}
            onClick={() => setShowMenu(false)}
          >
            <div className="main-menu">
              <div className="x-mark" onClick={() => setShowMenu(false)}>
                <HiXMark />
              </div>
              <ul>
                {list.map((item, i) => (
                  <li key={item + i}>
                    <HashLink smooth to={`/#${slugify(item).toLowerCase()}`}>
                      {item}
                    </HashLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <button className="btn-main">
            <HashLink smooth to="/#areas">
              Check areas
            </HashLink>
          </button>
          <div className="menu" onClick={() => setShowMenu(true)}>
            <RiMenu3Fill />
          </div>
        </div>
      </Container>
    </nav>
  );
};

export default NavBar;
